import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../contexts/AuthProvider";
import { backendService } from "../services/backend.service";
import type { ShiftPunchEvent } from "../utils/models";

type UseShiftPunchesResult = {
	data: ShiftPunchEvent[] | undefined;
	isLoading: boolean;
	error: unknown;
};

/**
 * DAT-221: fetches the raw HRIS punch events behind an actual shift.
 * SUPPORT-ONLY — the query is disabled (never hits the endpoint) unless the current user
 * is a support user, so non-support users never trigger the 403-gated call.
 */
export const useShiftPunches = (shiftId: string): UseShiftPunchesResult => {
	const { userInfo } = useAuth();
	const isSupport = !!userInfo?.support;

	const query = useQuery<ShiftPunchEvent[]>({
		queryKey: ["actual-shift-punches", shiftId],
		queryFn: async () => {
			const { data } = await backendService.getActualShiftPunches(shiftId);
			return data;
		},
		enabled: isSupport && !!shiftId,
	});

	return { data: query.data, isLoading: query.isLoading, error: query.error };
};
